import legalNotices from 'components/terms/legalNotices';
import TermsRouter from './TermsRouter';

export default {
  path: 'terms',

  getChildRoutes(location, cb) {
    cb(null, [legalNotices]);
  },

  getComponents(location, cb) {
    cb(null, TermsRouter);
  },
};
